export default {
    ALREADY_EXISTS: 'Гильдия с таким названием уже существует.',
    ALREADY_IN_GUILD: 'Вы уже состоите в гильдии.',
    CANNOT_KICK_YOURSELF: 'Вы не можете выгнать себя из гильдии.',
    GUILD_FULL: 'Эта гильдия работает на пределе возможностей,нет мест',
    MUST_FINISH_TUTORIAL_CREATE: 'Перед созданием гильдии необходимо завершить обучение.',
    NO_PERMISSION: 'У вас нет на это разрешения.',
    NO_PERMISSION_RANK: 'У вас нет разрешения на обновление ранга этого пользователя.',
    NOT_ENOUGH_GOLD: 'Для создания гильдии необходимо иметь в инвентаре 30,000 золотых.',
    NOT_ALLOWED_GUESTS_JOIN: 'Гостям не разрешается вступать в гильдии.',
    NOT_ALLOWED_GUESTS_CREATE: 'Гости не могут создавать гильдии.'
} as const;
